import $http from '$http';
import { cloneDeep, util, isCorrectVal, isDate, lg } from 'utils';
import { ClearIMEI } from '@api/agentApi.js'

export default {
    methods: {
        clearIMEIService(AgentId) {
            ClearIMEI({
                Sid: this.sysSid,
                Session: this.sysSession,
                AgentId: AgentId
            }).then(res => {
                let { Data } = res.data;
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '清理成功！',
                        type: 'success'
                    });
                    this.getList();
                });
            });
        },
        //获取意向客户数据
        getAgent(Id) {

            let $message = this.$message({
                message: '正在获取数据，请稍后...',
                duration: 0
            });

            this.$nextTick(() => {
                var Params = {
                    Sid: this.sysSid,
                    Session: this.sysSession,
                    Id: Id
                };
                $http.get('api/Agent/GetNewAgentByCustomerId', Params).then(res => {
                    let { Data } = res.data;
                    $message.close();
                    util.doResult(this, res, () => {
                        this.editData = Data;
                        this.modifyDialogVisiable = true;
                    });
                });
            });
        },
        getList() {

            if (this.$route.path == '/crmAgent/searchFormatAgent') {
                
                if (util.isEmptyObject(this.filterData)) {
                    this.lists=[];
                    return;
                }
                let flag = 0;
                for (let item in this.filterData) {
                    if ($.trim(this.filterData[item]).length > 0) {
                        flag = 1;
                    }
                }
                if (flag==0) {
                    this.lists=[];
                    return;
                }
                //return;
            }

            this.loading = true;//拼命加载中显示
            let Params = { Sid: this.sysSid, Session: this.sysSession, pageIndex: this.pageIndex, pageSize: this.pageSize };
            Params = Object.assign({}, Params, this.filterData);
            $http.get("api/Agent/GetFormatAgentList", Params).then(res => {
                let { Data, Cnt } = res.data;
                util.doResult(this, res, () => {
                    this.totalSize = Cnt;
                    this.loading = false;//拼命加载中显示
                    this.lists = Data;
                });
            });
        },
        req_AgentPoorReceive(data) {
            $http.post('api/Agent/Agent_PoorReceive', data).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '接收成功！',
                        type: 'success'
                    });
                    this.getList();
                });
            });
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/ViewCRMFormatAgent/services.js